export const iconFontAwesomeMapsUmbrella = (
	<i className="fa-solid fa-umbrella"></i>
);
